module.exports = __webpack_public_path__ + "26b440cff1effd6089e7d9e9c96e46e0.png";